import { PROJECTS_STATUSES } from 'constants/projects'

export const getProjectStatusColor = status => {
    if (status === PROJECTS_STATUSES.PUBLISHED) return '#65BB5A'
    if (status === PROJECTS_STATUSES.DRAFT) return '#8A8A8A'
    if (status === PROJECTS_STATUSES.DELETED) return '#FA655C'
    return 'inherit'
}
